import { Card, CardContent, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { isMobile } from "react-device-detect";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "./index.scss";

export default function SliderPassoPassoSimulacao() {
  return (
    <Container
      className="secao-landing-page-parcelamento-pix slider-passo-a-passo">
      <Grid container className="cards-passo-a-passo">
        <Swiper
          spaceBetween={50}
          navigation={isMobile ? false : true}
          modules={[Navigation, Pagination]}
          pagination={{
            dynamicBullets: true,
            clickable: true,
            bulletClass: "swiper-pagination-bullet",
          }}
          breakpoints={{
            600: {
              slidesPerView: 1,
            },
            1000: {
              slidesPerView: 1,
            },
          }}>
          <SwiperSlide key={1} className="swiper-slide">
            <Card className="card-instrucao">
              <CardContent>
                <Typography className="titulo">
                  1. Informe seus dados sem nenhum custo.
                </Typography>

                <Typography className="descricao">
                  <strong>Depois de selecionar a opção desejada</strong>, insira os dados necessários para prosseguir.
                </Typography>

                <Grid className="container-imagem">
                  <img src="/landing-pages/parcelamento-pix/dados-simulacao.png" alt="dados-simulacao" />
                </Grid>
              </CardContent>
            </Card>
          </SwiperSlide>
          <SwiperSlide key={2} className="swiper-slide">
            <Card className="card-instrucao">
              <CardContent>
                <Typography className="titulo">
                  2. Simule o parcelamento e escolha as condições.
                </Typography>

                <Typography className="descricao">
                  Você pode <strong>simular sem custos</strong>.
                  Escolha o <strong>valor total</strong>
                  e a <strong>quantidade de parcelas</strong> que deseja parcelar.
                </Typography>

                <Grid className="container-imagem">
                  <img src="/landing-pages/parcelamento-pix/valores-simulacao.png" alt="valores-simulacao" />
                </Grid>
              </CardContent>
            </Card>
          </SwiperSlide>
          <SwiperSlide key={3} className="swiper-slide">
            <Card className="card-instrucao">
              <CardContent>
                <Typography className="titulo">
                  3. A Quita paga à vista e você parcela no cartão.
                </Typography>

                <Typography className="descricao">
                  <strong>Informe os dados do cartão de crédito</strong>, clique em “Pagar agora”. Agora é só aguardar a validação de segurança!
                </Typography>

                <Grid className="container-imagem">
                  <img src="/landing-pages/parcelamento-pix/pagamento-simulacao.png" alt="pagamento-simulacao" />
                </Grid>
              </CardContent>
            </Card>
          </SwiperSlide>

        </Swiper>
      </Grid>
    </Container>
  );
}
